// extracted by mini-css-extract-plugin
export default {"outer":"Photos_outer__3k4AK","box":"Photos_box__vrUX2","photo":"Photos_photo__jb71F"};